<app-breadcrumb [title]="'system license' | translate" [items]="['security' | translate]" [active_item]="'system license' | translate"></app-breadcrumb>
<div class="container-fluid">
    <div class="row">
<div class="col-sm-12 col-xl-6">
    <div class="card">
        <!--<div class="card-header">
            <h5>{{ 'form'|translate }}</h5>
        </div>-->
        <div class="card-body">
            <form [formGroup]="systemLicenceForm" (ngSubmit)="onFormSubmit()" id="ngForm">
			
				<!-- <div class="mb-3 row align-items-center">
					<label class="col-sm-3">{{ 'license key'|translate }} <span class="text-danger">*</span></label>
					<div class="col-sm-7">
						<input
							readonly
							class="form-control form-control-sm"
							type="text"
							placeholder="Ex. Main"
							formControlName="licenseKey"
							[ngClass]="{'is-invalid': fc['licenseKey'].invalid && isSubmitted}"
						/>
						<small class="invalid-feedback fst-italic" *ngIf="fc['licenseKey'].errors?.['required']">
							{{ 'this field is required'|translate }}
						</small>
						<div class="invalid-feedback" *ngIf="fc['licenseKey'].errors?.['serverError']">
							{{ fc['licenseKey'].errors?.['serverError'] }}
						</div>
					</div>
					<div class="col-sm-2" *ngIf="!id;">
						  <ng-container *ngIf="!licensing; else isLicensing">
							<button type="button" class="btn btn-sm btn-outline-secondary" (click)="generateLicenseKey()">
							  {{ 'generate' | translate }}
							</button>
						  </ng-container>
						  <ng-template #isLicensing>
							<button type="button" class="btn btn-sm btn-outline-secondary" disabled>
							  <i class="fa fa-spin fa-spinner me-2"></i>
							  {{ 'loading...' | translate }}
							</button>
						  </ng-template>
					</div>
				</div> -->
				
				<div class="mb-3 row align-items-center">
					<label class="col-sm-3">{{ 'license key'|translate }} <span class="text-danger">*</span></label>

					<div
						[class.col-sm-9]="id"
						[class.col-sm-7]="!id"
					>
						<input
							readonly
							class="form-control form-control-sm"
							type="text"
							placeholder="Ex. Main"
							formControlName="licenseKey"
							[ngClass]="{'is-invalid': fc['licenseKey'].invalid && isSubmitted}"
						/>
						<small class="invalid-feedback fst-italic" *ngIf="fc['licenseKey'].errors?.['required']">
							{{ 'this field is required'|translate }}
						</small>
						<div class="invalid-feedback" *ngIf="fc['licenseKey'].errors?.['serverError']">
							{{ fc['licenseKey'].errors?.['serverError'] }}
						</div>
					</div>

					<!-- Bouton "generate" visible seulement si !id -->
					<div class="col-sm-2" *ngIf="!id">
						<ng-container *ngIf="!licensing; else isLicensing">
							<button type="button" class="btn btn-sm btn-outline-secondary" (click)="generateLicenseKey()">
								{{ 'generate' | translate }}
							</button>
						</ng-container>
						<ng-template #isLicensing>
							<button type="button" class="btn btn-sm btn-outline-secondary" disabled>
								<i class="fa fa-spin fa-spinner me-2"></i>
								{{ 'loading...' | translate }}
							</button>
						</ng-template>
					</div>
				</div>



                <div class="row">
                    <div class="col-sm-12">
                        <div class="mb-3 row">
                            <label class="col-sm-3">{{ 'customer'|translate }} <span class="text-danger">*</span></label>
                            <div class="col-sm-9">
                                <ng-select
                                        [items]="customers"
                                        bindLabel="name"
                                        bindValue="id"
                                        placeholder="{{ 'choose a customer'|translate }}"
                                        formControlName="customer"
                                        [ngClass]="{'is-invalid': fc['customer'].invalid && isSubmitted}"
                                        [(ngModel)]="customerSelected">
                                </ng-select>
                                <small class="invalid-feedback fst-italic" *ngIf="fc['customer'].errors?.['required']">{{ 'this field is required'|translate }}</small>
                                <div class="invalid-feedback" *ngIf="fc['customer'].errors?.['serverError']">
                                    {{ fc['customer'].errors?.['serverError'] }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
						<div class="mb-3 row">
                            <label class="col-sm-3">{{ 'start at'|translate }} <span class="text-danger">*</span></label>
                            <div class="col-sm-9">
                                <input class="form-control form-control-sm" type="date" placeholder="Ex. dd:mm:yyy" formControlName="startAt" [ngClass]="{'is-invalid': fc['startAt'].invalid && isSubmitted}" >
								<div class="invalid-feedback" *ngIf="fc['startAt'].errors?.['serverError']">
									{{ fc['startAt'].errors?.['serverError'] }}
								</div>
                            </div>
                        </div>                       
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-12">
						<div class="mb-3 row">
                            <label class="col-sm-3">{{ 'end at'|translate }} <span class="text-danger">*</span></label>
                            <div class="col-sm-9">
                                <input class="form-control form-control-sm" type="date" placeholder="Ex. dd:mm:yyy" formControlName="endAt" [ngClass]="{'is-invalid': fc['endAt'].invalid && isSubmitted}" >
								<div class="invalid-feedback" *ngIf="fc['endAt'].errors?.['serverError']">
									{{ fc['endAt'].errors?.['serverError'] }}
								</div>
                            </div>
                        </div> 
                    </div>
                </div>
				
				<div class="row">
					<div class="col-md-12">
					
						<div class="mb-3 row">
                            <label class="col-sm-3">{{ 'enable ?'|translate }} <span class="text-danger">*</span></label>
                            <div class="col-sm-9">
                  
								<div class="btn-radio" >
									<div class="btn-group" data-bs-toggle="buttons">
										<div class="btn btn-light txt-dark">
											<div class="radio radio-dark">
												<input id="radio21" formControlName="isEnable" type="radio" value='1'>
												<label for="radio21">{{ 'yes'|translate }}</label>
											</div>
										</div>
										<div class="btn btn-light txt-dark">
											<div class="radio radio-dark">
												<input id="radio22" formControlName="isEnable" type="radio" value='0'>
												<label for="radio22">{{ 'no'|translate }}</label>
											</div>
										</div>
									</div>
								</div>
								
                            </div>
                        </div> 
						
					</div>
				</div>

            </form>
        </div>
        <div class="card-footer text-end">
            <div class="col-sm-9 offset-sm-3">

                <button form="ngForm" (submit)="onFormSubmit()" type="submit" class="btn btn-sm btn-primary" [disabled]=saving>
                    <i class="fa fa-save" style="margin-right: 5px;"></i>
                    <ng-container *ngIf="!saving; else isSaving">{{data ? update : create}}</ng-container>
                    <ng-template #isSaving>
                        {{ "submitting" | translate }} ...
                    </ng-template>
                </button>

                <button type="button" class="btn btn-sm btn-light ms-2" routerLink="/security/system-license"><i class="fa fa-times-circle" style="margin-right: 5px;"></i>{{ 'close'|translate }}</button>

            </div>
        </div>
    </div>
</div>
    </div>
</div>

